import { Tab } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledMuiTab = styled(Tab)(({ theme }) => ({
  background: "#ffffff",
  border: "1px solid #ebebf7",
  color: "#0042b0",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: 16,
  lineHeight: "20px",
  padding: "6px 24px",
  minWidth: "unset",
  maxWidth: "none",
  flex: "0 1 auto",
  whiteSpace: "nowrap",
  "&:first-of-type": {
    borderRadius: theme.spacing(1, 0, 0, 1),
  },
  "&:last-of-type": {
    borderRadius: theme.spacing(0, 1, 1, 0),
  },
  "&.MuiTab-root.Mui-selected": {
    background: "#363846",
    border: "1px solid #363846",
    color: "#ffffff",
  },
  "&.MuiTab-root.Mui-selected.Mui-disabled": {
    background: "#363846",
    border: "1px solid #363846",
    color: "#ffffff",
    opacity: 1,
  },
  [theme.breakpoints.down("xl")]: {
    fontSize: 14,
    padding: "4px 16px",
  },
  [theme.breakpoints.down("lg")]: {
    fontSize: 12,
    padding: "4px 16px",
  },
}));
